import { Link } from "react-router-dom";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-primary-950 border-t border-primary-900 mt-auto">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 rounded-md bg-accent-500 text-foreground-950 flex items-center justify-center text-lg font-bold">
                <i className="ri-movie-2-line"></i>
              </span>
              <span className="font-heading text-lg font-black text-foreground-50">
                岳母的诱惑
              </span>
            </div>
            <p className="text-sm text-primary-100/70 leading-relaxed">
              汇聚电影与电视剧的剧情介绍与观看推荐，为你梳理每一部值得细看的影视内容。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-foreground-50 font-bold mb-4 text-base">
              <Link to="/category?type=电影" className="hover:text-accent-400">
                电影内容
              </Link>
            </h4>
            <ul className="space-y-2 text-sm text-primary-100/70">
              <li><Link to="/category?type=电影&genre=剧情" className="hover:text-accent-400">剧情片</Link></li>
              <li><Link to="/category?type=电影&genre=悬疑" className="hover:text-accent-400">悬疑片</Link></li>
              <li><Link to="/category?type=电影&genre=爱情" className="hover:text-accent-400">爱情片</Link></li>
              <li><Link to="/category?type=电影&genre=喜剧" className="hover:text-accent-400">喜剧片</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-foreground-50 font-bold mb-4 text-base">
              <Link to="/category?type=电视剧" className="hover:text-accent-400">
                电视剧内容
              </Link>
            </h4>
            <ul className="space-y-2 text-sm text-primary-100/70">
              <li><Link to="/category?type=电视剧&genre=都市" className="hover:text-accent-400">都市剧</Link></li>
              <li><Link to="/category?type=电视剧&genre=悬疑" className="hover:text-accent-400">悬疑剧</Link></li>
              <li><Link to="/category?type=电视剧&genre=治愈" className="hover:text-accent-400">治愈剧</Link></li>
              <li><Link to="/category?type=电视剧&genre=剧情" className="hover:text-accent-400">剧情剧</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-foreground-50 font-bold mb-4 text-base">关于本站</h4>
            <ul className="space-y-2 text-sm text-primary-100/70">
              <li><Link to="/about" className="hover:text-accent-400">关于我们</Link></li>
              <li><Link to="/about#contact" className="hover:text-accent-400">联系与反馈</Link></li>
              <li><Link to="/about#disclaimer" className="hover:text-accent-400">免责声明</Link></li>
              <li><Link to="/" className="hover:text-accent-400">返回首页</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-800/60 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-primary-100/60">
          <p>© {year} 岳母的诱惑 · 本站内容为虚构演示，仅供展示用途。</p>
          <p>www.yuemudeyouhuo.example</p>
        </div>
      </div>
    </footer>
  );
}